export const adaptArea = (data: IArea): LocationArea => {
	return {
		id: data.id,
		name: data.name,
		region: data.region ?? null,
		areaManager: data.area_manager ?? null,
		lastsync: data.lastsync,
		createdAt: data.created_at,
		updatedAt: data.updated_at
	};
};

export const adaptAreas = (data: IArea[]): LocationArea[] => {
	return data.map(adaptArea);
};
